<template>
  <div class="free-accessories-order-bd tb">
    <custom-tab
      v-model="curTab"
      :list="tabData"
    >
    </custom-tab>
    <wait-confirm-item v-if="curTab === waitConfirm.value"> </wait-confirm-item>

    <wait-send-item v-if="curTab === waitSend.value"></wait-send-item>

    <send-processing-item v-if="curTab === sendProcessing.value"></send-processing-item>

    <has-send-item v-if="curTab === hasSend.value"></has-send-item>

    <has-return-item v-if="curTab === hasReturn.value"></has-return-item>

    <has-cancel-item v-if="curTab === hasCancel.value"></has-cancel-item>
  </div>
</template>

<script>
// 赠送送配件订单
import waitConfirmItem from './children/wait_confirm.vue';
import waitSendItem from './children/wait_send.vue';
import hasSendItem from './children/has_send.vue';
import hasCancelItem from './children/has_cancel.vue';
import hasReturnItem from './children/has_return.vue';
import sendProcessingItem from './children/send_processing.vue';

export default {
  name: 'freeAccessoriesOrder',
  mixins: [],
  components: {
    waitConfirmItem,
    waitSendItem,
    hasSendItem,
    hasCancelItem,
    sendProcessingItem,
    hasReturnItem,
  },
  props: {},
  data() {
    return {
      // 当前tab的选中值
      curTab: '',
    };
  },
  computed: {
    waitConfirm() {
      return {
        name: this.$t('crm_freeAccessoriesOrder.dai_que_ren'),
        value: 6,
      };
    },
    waitSend() {
      return {
        name: this.$t('crm_freeAccessoriesOrder.dai_fa_huo'),
        value: 20,
      };
    },
    sendProcessing() {
      return {
        name: this.$t('crm_freeAccessoriesOrder.yi_que_ren'),
        value: 10,
      };
    },
    hasSend() {
      return {
        name: this.$t('crm_freeAccessoriesOrder.yi_wan_cheng'),
        value: 80,
      };
    },
    hasReturn() {
      return {
        name: this.$t('crm_freeAccessoriesOrder.yi_tui_huo'),
        value: 90,
      };
    },
    hasCancel() {
      return {
        name: this.$t('crm_freeAccessoriesOrder.yi_zuo_fei'),
        value: 100,
      };
    },
    tabData() {
      const tabData = [];
      const funcView = this.funcView;
      // 待确认
      if (funcView.free_accessories_order_wait_confirm) {
        tabData.push(this.waitConfirm);
      }

      // 已确认
      if (funcView.free_accessories_order_send_processing) {
        tabData.push(this.sendProcessing);
      }

      // 待发货
      if (funcView.free_accessories_order_wait_send) {
        tabData.push(this.waitSend);
      }

      // 已完成
      if (funcView.free_accessories_order_has_send) {
        tabData.push(this.hasSend);
      }

      // 已退货
      if (funcView.free_accessories_order_has_return) {
        tabData.push(this.hasReturn);
      }

      // 已作废
      if (funcView.free_accessories_order_has_cancel) {
        tabData.push(this.hasCancel);
      }

      return tabData;
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    initDefaultTabVal() {
      if (this.getJump('bizState')) {
        this.curTab = +this.getJump('bizState');
        return;
      }
      if (this.tabData.length) {
        const firstItem = this.tabData[0];
        this.curTab = firstItem.value;
      }
    },
  },
  created() {},
  mounted() {
    this.getFuncView(null, () => {
      this.initDefaultTabVal();
    });
  },
};
</script>

<style lang="scss">
.free-accessories-order-bd {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
}
</style>
